// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"b3-z","displaySixCardTiles":"c3-z"};